<template>
  <v-app-bar color="secondary" density="compact" :flat="true">
    <v-toolbar-title class="text-button">{{ renderClinicalTrialsTitle(meshPresentationString, meshDescription) }} - {{ selected_menu_item.title }}</v-toolbar-title>

    <template v-slot:extension>
      <v-tabs v-model="selected_menu_item" align-tabs="title" show-arrows>
        <v-tab v-for="menu_item in menu_items" :key="menu_item.dashboard" :value="menu_item"
               :disabled="menu_item.accessRight && !isAuthorized(menu_item.accessRight)">
          {{ menu_item.title }}
        </v-tab>
      </v-tabs>
    </template>
  </v-app-bar>

  <v-window v-model="selected_menu_item" direction="horizontal">
    <v-window-item :key="dashboard_1.dashboard" :value="dashboard_1" transition="fade-transition"
                   reverse-transition="fade-transition" @group:selected="(event) => this.dashboard_1.visible = event.value">
      <ClinicalTrials :mesh-ids="this.mesh ? [this.mesh] : []" :mesh-description="this.meshDescription">
      </ClinicalTrials>
    </v-window-item>
  </v-window>
</template>

<script>
import ClinicalTrials from '@/components/ClinicalTrials.vue'
import {defineComponent} from "vue";

const DASHBOARD_1 = {
  title: 'Clinical trials',
  dashboard: 'Dashboard1',
  visible: true
};

export default defineComponent({
  name: 'ClinicalTrialsView',
  props: {
    mesh: String,
    meshPresentationString: String,
    meshDescription: String
  },
  components: {
    ClinicalTrials
  },
  data: () => ({
    dashboard_1: DASHBOARD_1,
    selected_menu_item: DASHBOARD_1,
    menu_items: [
      DASHBOARD_1
    ]
  }),
  methods: {
    isAuthorized(accessRight) {
      return this.$store.getters.stateUser
          && this.$store.getters.stateUser.access_rights
          && this.$store.getters.stateUser.access_rights.includes(accessRight)
    },
    renderClinicalTrialsTitle(meshPresentationString, meshDescription) {
      if (meshPresentationString && meshDescription) {
        return meshPresentationString + ': ' + meshDescription;
      }
      if (meshPresentationString) {
        return meshPresentationString;
      }
      if (meshDescription) {
        return meshDescription;
      }
      return 'Any MeSH term';
    }
  }
})
</script>
